module.exports = __webpack_public_path__ + "static/img/incheon-ad-auto-pt.1e1b603.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/incheon-ad-auto-pt.jpg
// module id = OSat
// module chunks = 0